module.exports = __webpack_public_path__ + "img/info-order-notes.11fbe66a.svg";